/* eslint-disable max-len */
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Delayed from '@assets/delayed.svg';
import Damaged from '@assets/damaged.svg';
import Lost from '@assets/lost.svg';
import Return from '@assets/return.svg';
import { useBehaviorData } from '@hooks';
import { ClaimOption } from '@components';
import { ClaimType, ErrorCode } from '@constants';
import {
  setClaimInfo, setPackageList,
} from '@store';
import {
  getPackage,
} from '@api';
import { logError } from '@log';
import { clearSelectedItems, setDelayPackageId } from '@store/slices/claimSlice';

import classes from './index.module.css';

const SUB_TITLE = 'Please tell us what happened to your order?';

const useOptionList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setReportData = useBehaviorData();
  const { policyList } = useSelector((state) => state.policy);

  const onClickContinue = async (type, item) => {
    dispatch(setClaimInfo({ type, ...item }));
    setReportData({ chooseItemTime: Date.now() });
    try {
      const resp = await getPackage(item.policyId, type);
      const { code, data } = resp;
      // console.log('ra packagedata', data);
      const errorMap = [ErrorCode.Expired, ErrorCode.Total, ErrorCode.Cancelled, ErrorCode.HasOldClaim, ErrorCode.CoverdItemEmpty];

      if (code === 0) {
        dispatch(setPackageList(data));
        navigate('/17track/choose');
        dispatch(clearSelectedItems());
        dispatch(setDelayPackageId());
      } else if (errorMap.includes(code)) {
        navigate('/17track/error', { state: { code } });
      } else {
        navigate('/17track/error', { state: { code: ErrorCode.Wrong } });
      }
    } catch (e) {
      logError(e);
    }
  };

  const list = policyList.map((item) => {
    if (item.policyType === ClaimType.RA) {
      return {
        id: 'RA',
        icon: Return,
        title: 'I want to return the item(s)',
        onClick: () => onClickContinue(ClaimType.RA, item),
      };
    }
    return [{
      id: 'delay',
      icon: Delayed,
      title: 'My package was delayed',
      onClick: () => onClickContinue(ClaimType.Delay, item),
    }, {
      id: 'damage',
      icon: Damaged,
      title: 'My item(s) was damaged',
      hoverText: 'NOTE: Issues of damage must be reported within 15 days after the delivery date.',
      onClick: () => onClickContinue(ClaimType.Damage, item),
    }, {
      id: 'lost',
      icon: Lost,
      title: 'My item(s) was lost',
      onClick: () => onClickContinue(ClaimType.Loss, item),
    }];
  }).flat();

  return {
    optionList: list,
  };
};

export const Options = () => {
  const {
    firstName,
  } = useSelector((state) => state.policy);
  const { optionList } = useOptionList();

  return (
    <section className={classes.content}>
      <section className={classes.title}>
        Hi
        <section className={classes.customerName}>{firstName}</section>
        !
      </section>
      <section className={classes.sub_title}>{SUB_TITLE}</section>
      {optionList.map((option) => (
        <ClaimOption
          key={option.id}
          icon={option.icon}
          title={option.title}
          hoverText={option.hoverText}
          onClick={option.onClick}
        />
      ))}
    </section>
  );
};
